export default (projectName: string) => `{
  "name": "${projectName}",
  "version": "0.1.0",
  "private": true,
  "scripts": {
    "start": "node dist/server.js",
    "build": "tsc",
    "dev": "nodemon --exec ts-node src/server.ts"
  },
  "dependencies": {
    "express": "^5.1.0",
    "cors": "^2.8.5",
    "dotenv": "^16.5.0",
    "@prisma/client": "^6.7.0"
  },
  "devDependencies": {
    "typescript": "^5.8.3",
    "@types/express": "^5.0.1",
    "@types/cors": "^2.8.18",
    "@types/node": "^22.15.17",
    "ts-node": "^10.9.2",
    "nodemon": "^3.1.10",
    "prisma": "^6.7.0"
  }
}`;